import { useTranslation, Trans } from "react-i18next";

import Button from '../Button'

import main from '../../img/Home/main.png';
import phone from '../../img/Home/phone.png'
import m1 from '../../img/Home/m1.svg';
import m2 from '../../img/Home/m2.svg';
import m3 from '../../img/Home/m3.svg';
import m4 from '../../img/Home/m4.svg';

import Fade from 'react-reveal/Fade'

function Main () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative bg-[#131313]">
            <img src={main} className="absolute left-1/2 -translate-x-1/2" alt="" />
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto relative z-20 flex flex-col xl:flex-row justify-between gap-[20px]">
                <div className="flex flex-col items-start">
                    <Fade left><p className="text-[36px] xl:text-[64px] manrope text-white mt-[40px] xl:mt-[100px] font-[500] leading-[1.2]">Dorean–</p></Fade>
                    <Fade left delay={200}><p className="text-[24px] xl:text-[48px] manrope text-white font-[500] leading-[1.2] xl:max-w-[640px]">{t('home.1')}</p></Fade>
                    <Fade left delay={300}><Button className={'mt-[40px] xl:mt-[60px]'} main/></Fade>
                    <div className="grid grid-cols-1 xl:grid-cols-2 mt-[60px] xl:mt-[110px] gap-[10px]">
                        <Fade delay={400}><div className="flex items-center gap-[20px] py-[20px] px-[20px] xl:px-[25px] rounded-[20px] border border-[#FFFFFF1A] bg-[#FFFFFF1A]">
                            <img src={m1} alt="" />
                            <p className="xl:max-w-[247px] roboto text-[14px] text-[#FFFFFFB3] spantext"><Trans>{t('home.3')}</Trans></p>
                        </div></Fade>
                        <Fade delay={600}><div className="flex items-center gap-[20px] py-[20px] px-[20px] xl:px-[25px] rounded-[20px] border border-[#FFFFFF1A] bg-[#FFFFFF1A]">
                            <img src={m2} alt="" />
                            <p className="xl:max-w-[247px] roboto text-[14px] text-[#FFFFFFB3] spantext"><Trans>{t('home.4')}</Trans></p>
                        </div></Fade>
                        <Fade delay={800}><div className="flex items-center gap-[20px] py-[20px] px-[20px] xl:px-[25px] rounded-[20px] border border-[#FFFFFF1A] bg-[#FFFFFF1A]">
                            <img src={m3} alt="" />
                            <p className="xl:max-w-[247px] roboto text-[14px] text-[#FFFFFFB3] spantext"><Trans>{t('home.5')}</Trans></p>
                        </div></Fade>
                        <Fade delay={1000}><div className="flex items-center gap-[20px] py-[20px] px-[20px] xl:px-[25px] rounded-[20px] border border-[#FFFFFF1A] bg-[#FFFFFF1A]">
                            <img src={m4} alt="" />
                            <p className="xl:max-w-[247px] roboto text-[14px] text-[#FFFFFFB3] spantext"><Trans>{t('home.6')}</Trans></p>
                        </div></Fade>
                    </div>
                </div>
                <Fade bottom delay={1000}><img src={phone} alt="" className="mt-[90px] xl:mt-[240px] mx-auto pr-[20px] xl:pr-0"/></Fade>
            </div> 
        </div>
    );
}

export default Main;